import { Item } from './item';
export class Section {
  public id: number;
  public order: number;
  public created_at: string;
  public updated_at: string;
  public items: Item[];
  public row_start: number;
  public row_end: number;
  public column_start: number;
  public column_end: number;

  public get rowLength() {
    return this.row_end - this.row_start;
  }
  public get columnLength() {
    return this.column_end - this.column_start;
  }
  public get gridItemClasses() {
    return `
      grid-row-start-${this.row_start}
      grid-row-end-${this.row_end}
      grid-column-start-${this.column_start}
      grid-column-end-${this.column_end}
    `;
  }

  constructor(data: Section) {
    Object.assign(this, data);
    if (this.items) {
      this.items = this.items.map((item) => new Item(item));
    }
  }
}
